<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            :beforeSend="master.beforeSend"
            @action="masterActions"
            @handleOk="handleOk"
            ref="masterComponent"
            modalWidth="90%"
  >
    <template slot="expandedRowRender" slot-scope="{text}">
      <template v-for="ve in master.valoresExpandidos">
        {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
      </template>
    </template>
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Descripción Atributo')"
                      v-if="isCaracter"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :selectedObj.sync="attSeleccionado"
                      :decorator="['id_att', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :cache="false"
                      :params="id_att_car">
          </g-dropdown>
          <g-dropdown :label="$t('Descripción Atributo')"
                      v-if="!isCaracter"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :selectedObj.sync="attSeleccionado"
                      :cache="false"
                      :decorator="['id_att', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="id_att_num">
          </g-dropdown>
        </a-col>

        <a-col v-bind="colOptions">

          <a-row>
            <a-col :span="22">
              <g-dropdown
                v-show="listaValor"
                :label="$t('Valor Atributo')"
                :formItemConfig="fiOptions"
                endpoint="hierarchy_lookup_domains"
                :decorator="['att_value', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                :cache="false"
                :params="att_value_params">
              </g-dropdown>
              <a-form-item  v-show="!listaValor" :label="$t('Valor Atributo')" v-bind="fiOptions">
                <a-input

                  v-decorator="['att_value', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>

            </a-col>
            <a-col :span="2" >
              <a-popover title="Tipo de campo">
                <template slot="content">
                  <a @click="listaValor = true">Lista de valor</a>
                  <br>
                  <a @click="listaValor = false">Campo de texto</a>
                </template>
                <a-button style="margin-left: 0.3em; margin-top: 43px" type="primary" icon="select">
                </a-button>
              </a-popover>
            </a-col>
          </a-row>

        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha Inicial')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['att_init_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha Final')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['att_end_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" label="Observación">
            <a-textarea style="width: 100%"
                        v-decorator="['observacion', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    props: ['empleadoseleccionado', 'endpoint'],
    data () {
      return {
        isEdit: false,
        listaValor: true,
        tabList: [
          {
            key: 'Historico',
            tab: 'Historico'
          }
        ],
        attSeleccionado: {},
        id_att_car: {h_lookup_type: 'ATRIBUTOS CARACTER', use_code: true},
        id_att_num: {h_lookup_type: 'ATRIBUTOS', use_code: true},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        filtroValorNumerico: '',
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          beforeSend: (data) => {
            if (!this.$isEmpty(this.attSeleccionado)) {
              data.att_desc = this.attSeleccionado.text
            }
            return data
          },
          endpoint: this.endpoint,
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Id Atributo', dataIndex: 'id_att', sorter: true},
              {title: 'Descripción Atributo', dataIndex: 'att_desc', sorter: true},
              {title: 'Valor Atributo', dataIndex: 'att_value_desc', sorter: true},
              {title: 'Fecha Inicial', dataIndex: 'att_init_date_mask', sorter: true},
              {title: 'Fecha Final', dataIndex: 'att_end_date_mask', sorter: true},
              {title: 'Observacion', dataIndex: 'observacion', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_att'},
            {name: 'att_desc'},
            {name: 'att_init_date'},
            {name: 'att_end_date'},
            {name: 'att_value'},
            {name: 'observacion'},
            {name: 'tipo_campo'}
          ]
        }
      }
    },
    methods: {
      masterActions (action) {
        this.isEdit = false
        switch (action.action) {
          case 'masterEdit':
            this.filtroValorNumerico = action.record.id_att
            this.isEdit = true
            this.$nextTick(() => {
              this.listaValor = action.record.type_field
            })
            break
        }
      },
      handleOk () {
        this.$emit('handleOk')
      }
    },
    computed: {
      att_value_params () {
        if (this.$isEmpty(this.attSeleccionado.value)) {
          return {h_lookup_domain: this.filtroValorNumerico, use_code: true}
        } else {
          return {h_lookup_domain: this.attSeleccionado.value, use_code: true}
        }
      },
      isCaracter () {
        return this.endpoint === 'emp_att_car'
      },
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      },
      attSeleccionadoWatch () {
        return this.attSeleccionado.text
      }
    },
    watch: {
      attSeleccionadoWatch () {
        if (!this.isEdit) {
          this.$nextTick(() => {
            this.listaValor = true
          })
          this.$refs.masterComponent.modal.form.setFieldsValue({
            att_value: null
          })
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/AttributoCaracterNumerico.vue